import React from "react";

function LoggingOut() {
  return (
    <div style={styles.container}>
      <h1>🚪 Logging Out...</h1>
      <p>Hang tight, we're signing you out!</p>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "'Fredoka', cursive",
    fontSize: "1.8rem",
    backgroundColor: "#fcecec",
    color: "#d63031",
    textAlign: "center",
  },
};

export default LoggingOut;
